import type { MessageInputMethod } from "./surfaces";

/**
 * Sticky marker for how the next send was initiated. Follow-up chips,
 * suggested actions and template prompts fill the composer and trigger a
 * send indirectly; they mark the method here and useMessageActions consumes
 * it when the send carries no explicit method.
 */

const MAX_AGE_MS = 10_000;

let marked: { method: MessageInputMethod; at: number } | null = null;

export function markNextSendAs(method: MessageInputMethod): void {
  marked = { method, at: Date.now() };
}

export function consumeNextSendMethod(): MessageInputMethod | null {
  const m = marked;
  marked = null;
  if (!m || Date.now() - m.at > MAX_AGE_MS) return null;
  return m.method;
}

/** vitest only. */
export function clearNextSendMethodForTest(): void {
  marked = null;
}
